import { ChangeDetectionStrategy, Component, HostListener, Renderer2, RendererFactory2, Signal, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { AppState } from './common/state/root';
import { selectUserState } from './common/state/user/user.selectors';
import { UserState } from './common/state/user/user.state';
import { ColourMode, StylingService } from './common/services/styling/styling.service';
import { KeyboardService } from './common/services/keyboard/keyboard.service';
import { SideNavComponent } from './common/components/side-nav/side-nav.component';
import { TopNavComponent } from './common/components/top-nav/top-nav.component';
import { ToastComponent } from './common/components/toast/toast.component';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AlertPanelComponent } from './common/components/alert-panel/alert-panel.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [MatProgressSpinner, MatSidenavModule, SideNavComponent, TopNavComponent, ToastComponent, RouterOutlet, AlertPanelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  @ViewChild('sideNav', { static: false }) sideNav!: MatSidenav;
  @ViewChild('alertPanel', { static: false }) alertPanel!: MatSidenav;
  title = 'Lytehouse';
  public user: Signal<UserState>;
  private renderer: Renderer2;

  constructor(
    private store: Store<AppState>,
    private stylingService: StylingService,
    private rendererFactory: RendererFactory2,
    private keyboardService: KeyboardService
  ) {
    window.console.info = function () {};
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.user = this.store.selectSignal(selectUserState);
    this.stylingService.sideNavToggle$.subscribe((open) => {
      if (!!this.sideNav) {
        if (open) {
          this.sideNav.open()
        } else {
          this.sideNav.close()
        }
      }
    })

    this.stylingService.alertPanelToggle$.subscribe((open) => {
      if (!!this.alertPanel) {
        if (open) {
          this.alertPanel.open()
        } else {
          this.alertPanel.close()
        }
      }
    })

    this.stylingService.colourMode$.subscribe(e => {
      if (e == ColourMode.DARK) {
        this.renderer.addClass(document.body, "dark");
      } else {
        this.renderer.removeClass(document.body, "dark");
      }
    })
  }

  @HostListener('window:keydown', ['$event'])
  onKeyboardPressed(keyboardEvent: KeyboardEvent) {
    this.keyboardService.pushEvent(keyboardEvent)
  }

  get isDesktop(): boolean {
    return window.innerWidth >= 1200
  }

}
